import { render, staticRenderFns } from "./IdeaSolventsDetailed.vue?vue&type=template&id=6091c153&"
import script from "./IdeaSolventsDetailed.vue?vue&type=script&lang=js&"
export * from "./IdeaSolventsDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports